import { Box, Container, Typography, Button } from "@mui/material";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import sapSilverLogo from "../../assets/home/sap-silver-partner-logo.png";
import sapLogo from "../../assets/home/sap-logo-svg.svg";

const SapPartnerSection = () => {
  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg">
        <Box sx={styles.wrapper}>
          {/* Left Content */}
          <Box sx={styles.content}>
            <Box sx={styles.badge}>
              <VerifiedOutlinedIcon sx={{ fontSize: 20 }} />
              SAP Partner
            </Box>

            <Typography variant="h5" sx={styles.title}>
              Trusted SAP Partner for Digital Transformation
            </Typography>

            <Typography sx={styles.description}>
              ZENCON is proud to be an SAP Partner, delivering reliable SAP
              consulting, implementation, integration, and support services to
              help enterprises modernize operations and accelerate business
              growth.
            </Typography>

            <Typography sx={styles.subText}>
              We empower organizations with intelligent SAP solutions, process
              automation, and enterprise technologies designed to improve
              efficiency, visibility, and long-term performance.
            </Typography>

            {/* <Button endIcon={<ArrowForwardIcon />} sx={styles.button}>
              Explore Our SAP Services
            </Button> */}
          </Box>

          {/* Right Logo Card */}
          <Box sx={styles.logoCard}>
            <Box sx={styles.glow} />
            <Box
              component="img"
              src={sapLogo}
              alt="SAP Silver Partner"
              sx={styles.logo}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const styles = {
  section: {
    position: "relative",
    py: { xs: 8, md: 12 },
    background: "linear-gradient(135deg, #071525 0%, #082d63 100%)",
    color: "#fff",
    overflow: "hidden",
  },

  wrapper: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
    alignItems: "center",
    gap: { xs: 5, md: 8 },
  },

  content: {
    position: "relative",
    zIndex: 2,
  },

  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    px: 2,
    py: 1,
    mb: 3,
    borderRadius: "50px",
    background: "rgba(255,255,255,0.1)",
    border: "1px solid rgba(255,255,255,0.18)",
    color: "#d9e8ff",
    fontSize: 14,
    fontWeight: 600,
  },

  title: {
    fontSize: {
      xs: "1.5rem",
      sm: "2rem",
      md: "2.5rem",
    },
    fontWeight: 800,
    lineHeight: 1.1,
    maxWidth: 760,
    mb: 3,
  },

  description: {
    fontSize: { xs: "0.8rem", md: "1rem" },
    lineHeight: 1.8,
    color: "rgba(255,255,255,0.86)",
    maxWidth: 600,
    mb: 2,
    textAlign: "justify",
  },

  subText: {
    fontSize: { xs: 12, md: 16 },
    lineHeight: 1.8,
    color: "rgba(255,255,255,0.68)",
    maxWidth: 600,
    mb: 4,
    textAlign: "justify",
  },

  button: {
    px: 3.5,
    py: 1.4,
    borderRadius: "50px",
    background: "#00c853",
    color: "#fff",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "0 15px 35px rgba(0,200,83,0.25)",
    "&:hover": {
      background: "#00b84c",
      transform: "translateY(-2px)",
      boxShadow: "0 20px 45px rgba(0,200,83,0.35)",
    },
    transition: "all 0.3s ease",
  },

  logoCard: {
    position: "relative",
    zIndex: 2,
    // minHeight: { xs: 260, md: 420 },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: { xs: 1, md: 5 },
    borderRadius: "32px",
  },

  logo: {
    // width: "100%",
    maxWidth: { xs: 200, sm: 200, md: 300 },
    height: "auto",
    position: "relative",
    zIndex: 2,
    filter: "drop-shadow(0 25px 35px rgba(0,0,0,0.35))",
  },

  glow: {
    position: "absolute",
    width: 260,
    height: 260,
    borderRadius: "50%",
    background: "rgba(0, 200, 255, 0.25)",
    filter: "blur(70px)",
  },
};

export default SapPartnerSection;
